import React from 'react';
import { motion } from 'framer-motion';
import { Section, fadeInUp, staggerContainer } from './ui/Section';
import { CheckCircle2 } from 'lucide-react';
export function WhoIsItFor() {
  return <Section darker id="who-is-it-for" data-id="element-168">
      <motion.div initial="hidden" whileInView="visible" viewport={{
      once: true,
      margin: '-100px'
    }} variants={staggerContainer} className="max-w-4xl mx-auto" data-id="element-169">
        <motion.div variants={fadeInUp} className="text-center mb-12" data-id="element-170">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-4" data-id="element-171">
            ¿Para Quién Es{' '}
            <span className="text-gold-gradient" data-id="element-172">Este Paquete</span>?
          </h2>
          <div className="w-24 h-1 bg-gold-gradient mx-auto" data-id="element-173"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-8" data-id="element-174">
          {['Mujeres plus size (de tallas 2XL a 5XL).', 'Mujeres que viven en Estados Unidos.', 'Mujeres que han probado otras fajas y no han visto resultados.', 'Mujeres que buscan una solución completa, no solo un producto.', 'Mujeres que quieren asesoría personalizada para la elección de su faja y un gran servicio postventa.'].map((item, index) => <motion.div key={index} variants={fadeInUp} className="flex items-start gap-4" data-id="element-175">
              <CheckCircle2 className="w-6 h-6 text-gold-DEFAULT flex-shrink-0 mt-1" data-id="element-176" />
              <span className="text-lg text-gray-300" data-id="element-177">{item}</span>
            </motion.div>)}
        </div>
      </motion.div>
    </Section>;
}